import React from 'react';
import Lottie from 'react-lottie';
import { Wrapper, Message, Buttons } from '@components/SuccessSubmission/styles';
import Button, { BUTTON_THEME } from '@components/Button';
import SuccessAnimation from '@assets/lottie/success.json';
import MailSentAnimation from '@assets/lottie/mail-sent.json';

export enum ANIMATION {
  SUCCESS = 'success',
  MAIL_SENT = 'mailSent',
}

interface SuccessSubmissionProps {
  message: string;
  confirmClick: () => void;
  cancelClick?: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  animation?: ANIMATION;
}

function SuccessSubmission({
  message,
  confirmClick,
  cancelClick,
  confirmButtonText,
  cancelButtonText,
  animation,
}: SuccessSubmissionProps) {
  const animations = {
    success: SuccessAnimation,
    mailSent: MailSentAnimation,
  };

  const animationOptions = {
    loop: false,
    autoplay: true,
    animationData: animations[animation],
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Wrapper>
      <Lottie options={animationOptions} height={280} width={280} />

      <Message>{message}</Message>

      <Buttons>
        <Button onClick={confirmClick}>{confirmButtonText}</Button>
        {cancelButtonText ? (
          <Button onClick={cancelClick} buttonTheme={BUTTON_THEME.SECONDARY}>
            {cancelButtonText}
          </Button>
        ) : null}
      </Buttons>
    </Wrapper>
  );
}

SuccessSubmission.defaultProps = {
  animation: ANIMATION.SUCCESS,
  cancelButtonText: null,
  cancelClick: null,
  confirmButtonText: 'OK',
};

export default SuccessSubmission;
